import { render, staticRenderFns } from "./ItemComentario.vue?vue&type=template&id=50788adc&scoped=true&"
import script from "./ItemComentario.vue?vue&type=script&lang=js&"
export * from "./ItemComentario.vue?vue&type=script&lang=js&"
import style0 from "./ItemComentario.vue?vue&type=style&index=0&id=50788adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50788adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
